export const getRankInfo = (promptCount) => {
  if (!promptCount) return { title: 'มือใหม่หัดสร้าง', icon: '🌱' };
  if (promptCount < 100) return { title: 'มือใหม่หัดสร้าง', icon: '🌱' };
  if (promptCount < 1000) return { title: 'นักสร้างมือทอง', icon: '🏅' };
  if (promptCount < 5000) return { title: 'ปรมาจารย์ Prompt', icon: '🎯' };
  if (promptCount < 10000) return { title: 'เทพแห่ง AI', icon: '⚡' };
  if (promptCount < 100000) return { title: 'ตำนานนักสร้าง', icon: '👑' };
  return { title: 'จักรพรรดิ AI', icon: '🔮' };
}; 